import { useSelector } from "react-redux";

const useAllStores = () => {
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  return { storeList };
};
export default useAllStores;
